import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import agreement from './../store/modules/agreement/'
import currencytype from './../store/modules/currencytype/'
import customer from './../store/modules/customer/'
import debtor from './../store/modules/debtor/'
import factoredinvoice from './../store/modules/factoredinvoice/'
import invoice from './../store/modules/invoice/'
import filetype from './../store/modules/filetype/'
import invoicepaymenttype from './../store/modules/invoicepaymenttype/'
import invoicetaxtype from './../store/modules/invoicetaxtype/'
import transfertype from './../store/modules/transfertype/'
import company from './../store/modules/company/'
import user from './../store/modules/user/'
import security from './../store/modules/security/'
import config from './../store/modules/config/'
import payment from './../store/modules/payment/'
import deduction from './../store/modules/deduction/'
import report from './../store/modules/report/'

export default new Vuex.Store({
  modules: {
    agreement,
    currencytype,
    customer,
    debtor,
    factoredinvoice,
    invoice,
    filetype,
    invoicepaymenttype,
    invoicetaxtype,
    transfertype,
    company,
    user,
    security,
    config,
    payment,
    deduction,
    report
  }
})


// WEBPACK FOOTER //
// ./src/config/store.js